<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <new-form-box list-url="/" :id="id" checklist-type="store" :form-type="formType" @add="onAdd" @edit="onEdit">
      </new-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import NewFormBox from '../../components/NewFormBox.vue';

export default {
  name: 'NewForm',
  components: {
    NewFormBox
  },
  async mounted() {
    if (this.$route.name === 'form-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'form',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Create New Form' : 'Update Form';
    },
    ...mapState('form', ['loading'])
  },
  methods: {
    ...mapActions('form', ['getOne', 'postOne', 'patchOne']),
    onAdd({ form }) {
      this.postOne({
        form,
        router,
        redirectUrl: '/form'
      });
    },
    onEdit({ form }) {
      this.patchOne({
        type: 'form',
        id: this.id,
        form,
        router,
        redirectUrl: '/form'
      });
    }
  }
};
</script>
